import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { ApiService } from './../../../../../Services/api.service';
import { CommonServices } from './../../../../../Services/common.service';
@Component({
  selector: 'app-employee-booking-count',
  templateUrl: './employee-booking-count.component.html',
  styleUrls: ['./employee-booking-count.component.css']
})
export class EmployeeBookingCountComponent implements OnInit {

  public matFormSize = '12px';
  public empBookingForm: FormGroup;
  public noDataFoundEnable: boolean = false;
  public excelData = {};
  public currentDate: boolean = true;
  public formSubmitted: boolean = false;
  public showTable: boolean = false;
  public tableData: any = [];
  public showDownloadBtn: boolean = false;
  public errorObject: any = {};
  public maxDate = new Date();
  public maxEndDate = new Date();
  public date = new Date();

  // {
  //   "countTotal": 16,
  //   "countPickup": 9,
  //   "countDrop": 7,
  //   "employeeID": "626fac49388eb45c972c243a",
  //   "name": "Parameswara Rao",
  //   "empRefID": "TC4-197"
  // },
  // {
  //   "countTotal": 7,
  //   "countPickup": 0,
  //   "countDrop": 7,
  //   "employeeID": "6345312a2e9acf5d43c30788",
  //   "name": "Prasanna kumar",
  //   "empRefID": "abc124"
  // }

  public cols: any = [
    { key: '#', display: '#', minWidth: '60px' },
    {
      key: 'name', display: 'Employee name',
      config: {
        isTruncate: true,
        truncateData: {
          limit: 40,
          concatVal: '...',
        }
      },
      headerConfig:{ isDefault: true}
    },
    {
      key: 'empRefID', display: 'Employee ID',
      config: {
        isUppercase: true,
      },
      headerConfig:{ isDefault: true},
      minWidth: '75px',
    },
    {
      key: 'countPickup', display: 'Pick count',
      minWidth: '90px',
      headerConfig:{ isDefault: true}
    },
    {
      key: 'countDrop', display: 'Drop count',
      config: {
        isNumber: true,
      },
      headerConfig:{ isDefault: true},
      minWidth: '90px',
    },
  ];

  constructor(
    private api: ApiService,
    private com: CommonServices,
    private fb: FormBuilder,
    public excel: ExcelExportService,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
  }

  ngOnInit(): void {
    this.empBookingFormLoad();
    this.getEmpBookingCount({
      search: this.empBookingForm.value.search,
      startDate: new Date(new Date(this.empBookingForm.value.startDate).setHours(0, 0, 0, 0)).getTime(),
      endDate: new Date(new Date(this.empBookingForm.value.endDate).setHours(23, 59, 59, 999)).getTime(),
      minimumCount: +this.empBookingForm.value.minimumCount,
      isBooking: +this.empBookingForm.value.isBooking,
    });
  }

  empBookingFormLoad() {
    this.empBookingForm = this.fb.group({
      search: new FormControl(''),
      startDate: new FormControl(new Date()),
      endDate: new FormControl(new Date()),
      minimumCount: new FormControl('1', [Validators.required]),
      isBooking: new FormControl('1'),
    });
  }

  public checkError = (controlName: string, errorName: string) => {
    return this.empBookingForm.controls[controlName].hasError(errorName);
  }

  checkValidation() {
    let obj = {
      startDate: new Date(this.empBookingForm.value.startDate).getTime(),
      endDate: new Date(this.empBookingForm.value.endDate).getTime(),
    }
    if (this.formSubmitted) this.validation(obj);
  }

  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();

    }
  }
  setMaxDate() {
    let t_maxDate = new Date(this.empBookingForm.controls.startDate.value);
    //add a day to the date
    t_maxDate.setDate(t_maxDate.getDate() + 60);
    if (new Date() > t_maxDate) {
      this.maxEndDate = t_maxDate;
    }
    else {
      this.maxEndDate = new Date();
    }
    this.checkValidation();
  }

  validation(data) {
    if (this.errorObject['invalidDate']) delete this.errorObject['invalidDate'];
    let objectKeys = Object.keys(data);
    let isValid = true;
    for (let i = 0; i < objectKeys.length; i++) {
      let key = objectKeys[i];
      this.errorObject[key] = '';
      if (data[key] == '' || data[key] == undefined || data[key] == null || Number.isNaN(data[key]) || data.length <= 0) {
        this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
        isValid = false;
      } else if ((key == 'startDate' || key == 'endDate')) {
        let setDate = new Date(new Date(data.startDate).setDate(new Date(data.startDate).getDate() + 60)).getTime();
        if (new Date(data.startDate).getTime() > new Date(data.endDate).getTime()) {
          isValid = false;
          this.errorObject['invalidDate'] = 'Invalid end date';
        }
        else if (new Date(data.endDate).getTime() > setDate) {
          isValid = false;
          this.errorObject['invalidDate'] = 'Invalid end date';
        }
      }
    }
    return isValid;
  }

  onSubmit() {
    this.formSubmitted = true;
    this.showDownloadBtn = false;
    let checkObj = {
      startDate: new Date(this.empBookingForm.value.startDate).getTime(),
      endDate: new Date(this.empBookingForm.value.endDate).getTime(),
    }
    let isValid = this.validation(checkObj);
    if (isValid) {
      let obj = {
        startDate: new Date(new Date(this.empBookingForm.value.startDate).setHours(0, 0, 0, 0)).getTime(),
        endDate: new Date(new Date(this.empBookingForm.value.endDate).setHours(23, 59, 59, 999)).getTime(),
      }
      if (this.empBookingForm.value.search != '') obj['search'] = this.empBookingForm.value.search;
      if (this.empBookingForm.value.startDate != '') obj['startDate'] = new Date(new Date(this.empBookingForm.value.startDate).setHours(0, 0, 0, 0)).getTime();
      if (this.empBookingForm.value.endDate != '') obj['endDate'] = new Date(new Date(this.empBookingForm.value.endDate).setHours(23, 59, 59, 999)).getTime();
      if (this.empBookingForm.value.minimumCount != '') obj['minimumCount'] = +this.empBookingForm.value.minimumCount;
      if (this.empBookingForm.value.isBooking != '') obj['isBooking'] = +this.empBookingForm.value.isBooking;
      this.getEmpBookingCount(obj)
      this.showDownloadBtn = true;
    }
  }

  getEmpBookingCount(obj: any) {
    this.api.getEmployeeBookingCount(obj).then((res: any) => {
      this.tableData = [];
      if (res && res.status == 'success') {
        let getKeys = Object.keys(res['data'][0])
        if (res.data && res['data'][0] && getKeys && getKeys.length > 0) {
          getKeys.map((item: any) => {
            this.tableData.push(res['data'][0][item]);
          });
          this.showTable = true
          this.noDataFoundEnable = false;
        } else {
          this.tableData = [];
          this.noDataFoundEnable = true;
        }
      } else {
        this.tableData = [];
        this.noDataFoundEnable = true;
      }
    }).catch((err) => {
      console.log('error', err);
    })
    if (this.tableData.length <= 0) {
      this.noDataFoundEnable = true
    }
    if (this.tableData.length > 0) this.currentDate = false
  }


  async exportToExcel() {
    let data = [];
    const startDate = new Date(this.empBookingForm.value.startDate + '').setHours(0, 0, 0, 0);
    const endDate = new Date(new Date(this.empBookingForm.value.endDate + '').setHours(23, 59, 59, 999));


    for (let i = 0; i < this.tableData.length; i++) {
      let item = this.tableData[i];
      try {
        let res = {
          value: [
            i + 1,
            item.name ? this.com.convertTitleCase(item.name) : '---',
            item.empRefID ? String(item.empRefID).toUpperCase() : '---',
            Object.keys(item).includes('countPickup') ? (item.countPickup ? +item.countPickup : 0) : '---',
            Object.keys(item).includes('countDrop') ? (item.countDrop ? +item.countDrop : 0) : '---',
          ]
        };
        data.push(res);
      } catch (err) {
        console.log(err);
      }
    }
    if (data.length > 0) {
      let rowCount = 2;
      let endCell = 'E';
      let customizedData = [];
      let titleRow = {
        value: ['Employee Booking Count'],
        font: {
          name: 'Corbel', family: 4, size: 16, bold: true,
          color: { argb: 'FFFFFFFF' },
        },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
        alignment: {
          cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
        },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '966462AF' },
          bgColor: { argb: 'FFF' }
        },
      }

      customizedData.push(titleRow);

      rowCount += 3;
      let subtitleRow = {
        value: ["Title :" + ((this.empBookingForm.value.isBooking == 1) ? 'Booked' : (this.empBookingForm.value.isBooking == 0) ? 'Cancelled' : '---') + "\n" +
          "Start Date  : " + this.com.timestampToDate(new Date(startDate).getTime(), 'DMY') + "\n" +
          "End Date    : " + this.com.timestampToDate(new Date(endDate).getTime(), 'DMY')],
        font: { name: 'Corbel', family: 4, size: 12, },
        mergeCells: `A${(rowCount - 2 ) + ''}:${endCell + rowCount + ''}`,
      }

      customizedData.push(subtitleRow);

      rowCount += 1;
      let headerRow =
      {
        value: ['S No', 'Employee name', 'Employee ID', 'Pickup count', 'Drop count'],
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      }
      customizedData.push(headerRow);

      customizedData = [...customizedData, ...data];
      const excelInfo = {
        customizedData: customizedData,
        data: {
          columWith: [{ colNo: 2, width: 30 }, { colNo: 3, width: 25 }, { colNo: 4, width: 20 }, { colNo: 5, width: 20 }, { colNo: 6, width: 15 }, { colNo: 7, width: 35 }, { colNo: 8, width: 15 }, { colNo: 9, width: 15 }, { colNo: 10, width: 25 }, { colNo: 11, width: 15 }, { colNo: 12, width: 20 }]
        }
      };

      if (this.excelData['Employee_Booking_Count'] == undefined) { this.excelData['Employee_Booking_Count'] = {}; }
      this.excelData['Employee_Booking_Count'] = excelInfo;
      this.showDownloadBtn = true;

      this.downloadExlReport();
      console.log(this.excelData)
    }

  }

  downloadExlReport() {
    this.excel.generateExcel(this.excelData, 'Employee_Booking_Count' + new Date().getTime() + 'xlsx');
  }
}
